export function getPremiumImagePath(id) {
  return `/img/premium/${id}.jpg`;
}
